module.exports = __webpack_public_path__ + "media/time-management_de_ipad_old.19b700d4.mp4";